import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'glxy-prefix, [glxyPrefix]',
  standalone: false,
})
export class PrefixDirective {
  @HostBinding('class') class = 'glxy-prefix';
}
